//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../Weld/Weld.DatumCommonBuilder.js";
import "../no/ScCollector.js";
import "../Weld/Weld.SelectDatumPin.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"BoundaryCurve",0,"ScCollector",0],[0,"CreatePunchVector",1,0],[1,"DerivedDatum",0,"Weld.SelectDatumPin",0],[0,"PunchDirection",1,"Direction",0],[0,"PunchDirectionLength",1,0]],[[[],"MoveToCenter",{},0,0],[[],"InitializeAxis",{},0,0],[[],"UpdateAxisData",{},0,0]],[]];
SPLM.Weld.DatumPinBuilder = class extends SPLM.Weld.DatumCommonBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.DatumPinBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;